import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';

// @mui material components
import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import AuthenticationLayout from "../components/AuthenticationLayout";
// Images
import model from "assets/images/change.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "@emotion/styled";
import { useAuth } from "utlis/authContext";

// Styled ToastContainer
const StyledToastContainer = styled(ToastContainer)`
  /* Your styles here */
  .Toastify__toast {
    border-radius: 4px;
    background-color: white;
    height: auto; /* Add a semicolon to separate properties */
    color: black; /* Use "color" instead of "fontColor" */
  }
  .Toastify__toast--success {
  }

  .Toastify__toast--error {
  }
`;

const API_URL = process.env.REACT_APP_API_URL;
const API_TOKEN  = process.env.REACT_APP_API_TOKEN

function SignIn() {
  const navigate = useNavigate();
  const { login } = useAuth()
  const [rememberMe, setRememberMe] = useState(true);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const[isDisable,setIsDisable]=useState(false)

  const handleUsernameChange = (event) => {
    setError(false);
    setIsDisable(false)
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setError(false);
    setIsDisable(false)
    setPassword(event.target.value);
  };

  // if (error) {
  //   setTimeout(() => {
  //     setError(false);
  //   },1000);
  // }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsDisable(true)
    if (userName === "" || password === "") {
      setError(true);
      console.error("Input fields cannot be empty");
      return;
    }

    const post_data = {
      email: userName,
      password: password,
    };
    try {
        const response = await axios.post(`${API_URL}login-web`, post_data, {
        headers: { "api-token": API_TOKEN},
      });
      if (response.status === 200) {
        toast.success(response?.data?.message);
        login(response.data.data.access_token);
        console.log("retailerId", response.data.data.user.retailer_id)
        sessionStorage.setItem('shop_code', response.data.data.user.name);
        sessionStorage.setItem('retailerID', response.data.data.user.retailer_id);
        localStorage.setItem("walletAmount", response?.data?.data?.user?.wallet_balance);
        sessionStorage.setItem('userType', response.data.data.user.user_type);
        sessionStorage.setItem('monthlyCredit', response.data.data.user.monthly_credit);
             
         const simOnlyUser = response.data.data.user.sim_only_video_status
         sessionStorage.setItem('simOnlyUser', response.data.data.user.sim_only_video_status);

       if(simOnlyUser===1){
        navigate("/sim_only_video")
       }else{
         navigate("/dashboard")
       }

        

        window.onpopstate = function (event) {
          history.go(1);
          // navigate("/dashboard");
          if(simOnlyUser===1){
            navigate("/sim_only_video")
           }else{
             navigate("/dashboard")
           }
        };

      } else {
        toast.error(response?.data?.message);
        console.error("Please enter correct credentials");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error("An error occurred:", error);
    }
  };
  return (
    <AuthenticationLayout
      title="Welcome To Telsim Retailer Portal"
      description="Enter your Username and Password to sign in"
      image={model}
    >
      <StyledToastContainer hideProgressBar={false} position="top-right" autoClose={1000} />
      {error && (
          <SoftTypography variant="caption" color="error">
            {" "}
            Please enter valid credentials.Input fields cannot be empty.
          </SoftTypography>
        )}
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Username
            </SoftTypography>
          </SoftBox>
          <SoftInput
          id="username"
            type="text"
            placeholder="Username"
            value={userName}
            onChange={handleUsernameChange}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Password
            </SoftTypography>
          </SoftBox>
          <SoftInput
            id="password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={handlePasswordChange}
   
          />
        </SoftBox>
      
        {/* <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox> */}
        <SoftBox mt={4} mb={1}>
          <SoftButton variant="gradient" color="primary" disabled={isDisable} fullWidth onClick={handleSubmit}>
            Sign in
          </SoftButton>
        </SoftBox>

        <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t know your password?{" "}
            <SoftTypography
              component={Link}
              to="/forgotpassword"
              variant="button"
              color="primary"
              fontWeight="medium"
              textGradient
            >
              Forgot Password
            </SoftTypography>
          </SoftTypography>
        </SoftBox>


        <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            {/* Don&apos;t know your password?{" "} */}
            <SoftTypography
              component={Link}
              to="/contact_us"
              variant="button"
              color="primary"
              fontWeight="medium"
              textGradient
              sx={{border:"2px solid #cb0c9f" , padding :"4px" ,borderRadius:"5px" , fontSize:"15px"}}
            >
              Contact Us
            </SoftTypography>
          </SoftTypography>
        </SoftBox>












      </SoftBox>
    </AuthenticationLayout>
  );
}

export default SignIn;
